module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Left_16"],"polygon":[{"$":{"points":"10.32 14.24 3.52 8 10.32 1.76 11.68 3.24 6.48 8 11.68 12.76 10.32 14.24","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Left_16.svg
// module id = NbUA
// module chunks = 1